const styles = {
  '.MuiPaper-root': (theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: 328,
      minWidth: 328,
      '.MuiDialogTitle-root': {
        pb: 1,
      },
      '.MuiDialogActions-root': {
        gap: 1,
        '.MuiButtonBase-root': {
          flexBasis: '100%;',
          marginLeft: 0,
        },
      },
    },
    width: 600,
    minWidth: 600,
  }),
};

export default styles;
